import {useCallback, DependencyList, useRef, RefObject, MutableRefObject} from 'react';

export function useCallbackRef<T extends (...args: any[]) => any>(callback: T, deps: DependencyList): [T, MutableRefObject<T>] {
    const cbRef = useRef<T>(callback);
    const cb = useCallback(callback, deps);
    cbRef.current = cb;
    return [cb, cbRef];
}